'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const displayReasons = _ref => {
  var _currentSelection$chi, _currentSelection$chi2;
  let {
    reasons,
    selection
  } = _ref;
  const childNodes = reasons.reduce((acc, cur) => cur.childIds && cur.childIds.length > 0 ? [...acc, ...cur.childIds.map(id => reasons.find(reason => id === reason.id))] : acc, []);
  const rootNodes = reasons.filter(reason => reason.id ? !childNodes.map(_ref2 => {
    let {
      id
    } = _ref2;
    return id;
  }).includes(reason.id) : true);
  if (selection.length === 0) return rootNodes;
  const currentSelection = selection[selection.length - 1].id ? reasons.find(reason => reason.id === selection[selection.length - 1].id) : reasons.find(reason => reason.name === selection[selection.length - 1].name);
  if (currentSelection && !currentSelection.childIds || (currentSelection === null || currentSelection === void 0 ? void 0 : (_currentSelection$chi = currentSelection.childIds) === null || _currentSelection$chi === void 0 ? void 0 : _currentSelection$chi.length) === 0) {
    return [currentSelection];
  }
  return currentSelection === null || currentSelection === void 0 ? void 0 : (_currentSelection$chi2 = currentSelection.childIds) === null || _currentSelection$chi2 === void 0 ? void 0 : _currentSelection$chi2.map(childId => childNodes.find(_ref3 => {
    let {
      id
    } = _ref3;
    return id === childId;
  })).filter(Boolean);
};

exports["default"] = displayReasons;
